import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const SelectValue = ({ icon, label, value }) => {
  const iconClass = icon ? `Select-icon ico ico-${icon}` : '';
  return <span className={iconClass}>{label}</span>;
};
SelectValue.propTypes = {
  option: PropTypes.object.isRequired
};
SelectValue.displayName = 'SelectValue';

export default SelectValue;
